module.exports = __webpack_public_path__ + "img/sara.29e502e7.jpg";